import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsKey,
  getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodeClientAdminsStressAssessments200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import type { KeyedMutator } from 'swr';

const fetcher = (
  threeLetterCode: string,
  apiParams: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsParams
) =>
  customInstanceWithHeader<GetApiV1ThreeLetterCodeClientAdminsStressAssessments200>(
    getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsUrl(threeLetterCode, apiParams),
    { method: 'GET' }
  );

type Args = {
  threeLetterCode: string;
  page?: string;
};

type IUseGetStressAssessmentList = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessments200;
  totalPage: number;
  totalCount: number;
  mutate: KeyedMutator<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsStressAssessments200>
  >;
};

/**
 * ストレスチェック一覧取得フック
 */
export const useGetStressAssessmentList: IUseGetStressAssessmentList = ({
  threeLetterCode,
  page,
}) => {
  const apiParams: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsParams = {
    ...(page && !Number.isNaN(Number(page)) && { page: Number(page) }),
  };

  const { data, mutate } = useFetch<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsStressAssessments200>
  >(
    getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsKey(threeLetterCode, apiParams),
    () => fetcher(threeLetterCode, apiParams),
    { suspense: true }
  );

  const totalPage = Number(data.headers['total-pages']) || 0;
  const totalCount = Number(data.headers['total-count']) || 0;

  return {
    data: data.data,
    totalPage,
    totalCount,
    mutate,
  };
};
